import React, { useEffect, useContext, lazy, Suspense } from 'react';
import LoginForm from './LoginForm'
import Logo from './../../images/open-racer.inline.svg'
import Tracks from './../../images/racing-tracks-mix.jpg'

export default (props) => {
    return (
        <div className="absolute w-screen h-screen top-0 left-0 bg-white" style={{zIndex:1000}}> 
            <div className="flex h-full justify-center overflow-hidden">
                <div className="hidden lg:w-1/2 lg:flex lg:flex-col bg-gray-50 p-20">
                    <a href="/" className="shrink-0 flex items-center text-gray-900">
                        <Logo className="h-7"/>
                    </a>
                    <h2 className="text-4xl pt-10 text-gray-900 opacity-80 font-racing uppercase">Discover the world's top race tracks & drivers.</h2>
                    <img className="mt-auto" src={Tracks} style={{mixBlendMode: 'darken'}}/>
                </div>
                <div className="lg:w-1/2 flex-grow flex items-center justify-center p-8">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800 py-3">Sing in or create your profile</h2>
                        <LoginForm />
                    </div>
                </div>
            </div>
        </div>
    )
} 